import "@vojomo-core/shared/src/static/styles/App.css";
import { Routes, Route } from "react-router-dom";
import { RouteConfigProps, useAccount } from "@vojomo-core/shared";
import { clearCookies } from "@vojomo-core/shared";
import { routeConfig } from "./config/routeConfig";
import { Unauthorized } from "./pages/Errors/Unauthorized";

// Import all .jsx files from the ./pages directory
const pageComps: any = [];
const pages = import.meta.glob("./pages/**/*.*sx", { eager: true });
for (const path in pages) {
  pageComps.push(pages[path]);
}

function App() {
  const { vojomoAccount, userUnauthorized } = useAccount();

  // Render app
  if (vojomoAccount) {
    return (
      <Routes>
        {routeConfig.map(function (comp: RouteConfigProps) {
          const CompComponent = pageComps.find(
            (pageComp) => Object.keys(pageComp)[0] === comp.component
          )?.[comp.component];

          return (
            <Route
              key={comp.key}
              path={comp.path}
              element={<CompComponent />}
            />
          );
        })}
      </Routes>
    );
  } else if (userUnauthorized) {
    clearCookies();

    return <Unauthorized />;
  }
}

export default App;
